import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"8px"} }, "上传", -1)
const _hoisted_3 = { style: {"max-height":"calc(100vh - 300px)","overflow-y":"auto"} }
const _hoisted_4 = ["src"]

import { ref, reactive, computed } from 'vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { uploadFileApi } from '@/api/common'
import { businessCardCreate, businessCardUpdate } from '@/api/marketing/marketingManage'
import type { BusinessCardEditParams, BusinessCardListItem } from '@/typings/api/marketingManage'
import type { UploadFile } from 'ant-design-vue'


const __default__ = { name: 'ModalForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const initDefaultData = () => ({ fileList: [] })
const formRef = ref()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const dataForm = reactive<BusinessCardEditParams>(initDefaultData())
const formRules = reactive({
  select: [{ required: true, message: '请选择' }],
  upload: [{ required: true, message: '请上传' }]
})
const emit = __emit

const rowsProps = ref<BusinessCardListItem>()
// 弹窗标题
const modalTitle = computed(() => (rowsProps.value ? '编辑销售名片' : '新增销售名片'))
const init = (rows?: BusinessCardListItem) => {
  rowsProps.value = rows
  if (rows) {
    dataForm.id = rows.id
    dataForm.follower = rows.follower
    dataForm.fileList = [{ url: rows.businessCardPath }]
    dataForm.businessCardPath = rows.businessCardPath
  } else {
    for (const key in dataForm) {
      dataForm[key] = undefined
    }
    Object.assign(dataForm, initDefaultData())
  }
  visible.value = true
}
const beforeUpload = (file: UploadFile) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) DcMessage.error('您只能上传 JPG 或者 PNG 文件!')
  const isLt10M = file.size && file.size / 1024 / 1024 < 10
  if (!isLt10M) DcMessage.error('图片必须小于 10MB !')
  return isJpgOrPng && !!isLt10M
}
const customRequest = (options: any) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('files', options.file)
    uploadFileApi(formData)
      .then((res: any) => {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          DcMessage.error(res.message)
          reject(res.message)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
const backgroundImagesRequest = (options: any) => {
  customRequest(options)
    .then((res: any) => {
      dataForm.businessCardPath = res[0]
      dataForm.fileList = [{ url: res[0] }]
    })
    .catch(() => {
      dataForm.businessCardPath = ''
      dataForm.fileList = []
    })
    .finally(() => {
      formRef.value?.validateFields(['fileList'])
    })
}
// 预览图片
function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
const previewVisible = ref(false)
const previewImage = ref('')
const previewTitle = ref('')
const handlePreviewCancel = () => {
  previewVisible.value = false
  previewTitle.value = ''
}
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string
  }
  previewImage.value = file.url || file.preview
  previewVisible.value = true
  previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
}
const handleOk = async () => {
  try {
    await formRef.value?.validate()
    loading.value = true
    const params: BusinessCardEditParams = {
      follower: dataForm.follower,
      businessCardPath: dataForm.businessCardPath,
      id: rowsProps?.value?.id
    }
    const func = rowsProps?.value ? businessCardUpdate : businessCardCreate
    await func(params)
    DcMessage.success('操作成功！')
    emit('fetch')
    handleCancel()
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
const handleCancel = () => {
  formRef.value?.resetFields()
  visible.value = false
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    width: 600,
    title: modalTitle.value,
    confirmLoading: loading.value,
    destroyOnClose: "",
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        "wrapper-col": { span: 24 },
        ref_key: "formRef",
        ref: formRef,
        model: dataForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "销售员",
            name: "follower",
            rules: formRules.select
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UserSelect, {
                value: dataForm.follower,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.follower) = $event)),
                status: 1,
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            label: "上传名片",
            name: "fileList",
            rules: formRules.upload
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_upload, {
                "file-list": dataForm.fileList,
                "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.fileList) = $event)),
                action: "/base/resource/file/upload",
                "list-type": "picture-card",
                maxCount: 1,
                name: "files",
                "before-upload": beforeUpload,
                customRequest: backgroundImagesRequest,
                onPreview: handlePreview
              }, {
                default: _withCtx(() => [
                  (dataForm.fileList && dataForm.fileList.length < 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_unref(PlusOutlined)),
                        _hoisted_2
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["file-list"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_a_modal, {
        visible: previewVisible.value,
        title: previewTitle.value,
        footer: null,
        onCancel: handlePreviewCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              alt: "example",
              style: {"width":"100%"},
              src: previewImage.value
            }, null, 8, _hoisted_4)
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"])
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})